import React from 'react';
import Icon from './Icons/Icon';
import colours from './Colours';
import { InputLabel, P3, P3Bold } from './Text';
import PropTypes from 'prop-types';

const MessageCard = (props) => {
    let {variant, message} = props;

    const getVariant = () => {
        if (variant == 'info' || variant == 'error' || variant == 'warning' || variant == 'success')
            return variant;
        
        else return '';
    }

    const getColor = (variant) => {
        if (variant == 'info')
            return colours.primary.blue;
        
        if (variant == 'success')
            return colours.accent.validate_green;
        
        if (variant == 'error')
            return colours.accent.error_red;

        if (variant == 'warning')
            return colours.accent.caution_yellow;
        
        return colours.primary.grey03;
    }

    const getIcon = (variant) => {
        if (variant == 'info' || variant == 'error' || variant == 'warning')
            return "AttentionForm";
        
        if (variant == 'success')
            return "SuccessForm"
        
        return '';
    }

    return ( 
        <div>
            {(getVariant() !== '') && message ? 
                <div className={"ds-input-message" + " " + variant}>
                    <div className="ds-input-message-icon" style={{marginLeft: 0, display: 'unset'}}>
                        <Icon name={getIcon(getVariant())} size={16} style={{color: getColor(getVariant())}}/>
                    </div>
                    <P3 style={{color: colours.primary.grey01}}>
                        {message}    
                    </P3>
                </div>
            : null}
        </div>
    )
}

MessageCard.defaultProps = {
    variant: 'info',
    message: ''
}

MessageCard.propTypes = {
    variant: PropTypes.string,
    message: PropTypes.string,
}

export default MessageCard;